import { loadScoringGen7, setScoringTaskGen7 } from '../../scoringGen7';
import { FORM_FIELDS } from '../../../constants';
import { STRATEGY_LIST } from '../../../services/amazingScoring/amazingScoring.constants';

type TScoreGen7 = { score: number; isHit: boolean };
type ScoringTask = {
    scoreGen7cl?: TScoreGen7;
};

export const getScoring = async (formData: FE.FormData, userId?: string): Promise<ScoringTask> => {
    const { scores, task } = await setScoringTaskGen7(formData, userId);

    const gen7Result = task ? await loadScoringGen7(task.id) : await Promise.resolve({ scores, task });

    const scoreGen7cl = gen7Result.scores?.[STRATEGY_LIST.CL_GB_V1];

    return {
        scoreGen7cl,
    };
};

export const scoringToFormData = ({ scoreGen7cl }: ScoringTask): FE.FormData => {
    return {
        [FORM_FIELDS.SCORE_GEN7_CL]: scoreGen7cl?.score,
        [FORM_FIELDS.SCORE_GEN7_CL_HIT]: scoreGen7cl?.isHit,
    };
};
